import FutureAbsenceTable from "root/s360components/Tables/FutureAbsenceTable";
import SpinnerDiv from "ui/ReactSpinnerDiv";
import {useEffect, useState} from "react";
import {getFutureAbsencesForSchool} from "root/DataFunctions/FutureAbsenceDataFns";
import './FutureAbsenceManager.scss';

const FutureAbsenceManager = ({school_id, filter, onClickActivateFutureAbsenceModal, getData, data}) =>
{

    useEffect(() =>
    {
        getData(filter);
    }, [filter])

    return (
        <div>
            {data.isLoading === false && <FutureAbsenceTable data={data.data} onClickAction={onClickActivateFutureAbsenceModal}/>}
            {data.isLoading === true && <SpinnerDiv/>}
        </div>
    )
}

export default FutureAbsenceManager;